import { defineBool, defineEnum, PropertyRef } from '@spotify-internal/remote-config-properties';

/**
 * Define properties here and add them into the following array.
 * More on `docs/RemoteConfig/properties.md`
 */
export const ubiTestBool = defineBool({
  name: 'ubiTest',
  description: 'A/A-test to confirm integration towards UBI',
  default: false,
});

export const usePillowTalk = defineBool({
  name: 'usePillowTalk',
  description: 'Boolean to control wether or not to use pillow talk',
  default: true,
});

export const enableNewPremiumCloseAccount = defineBool({
  name: 'enableNewPremiumCloseAccount',
  description: 'Redirect to the new close account flow in www-account-pages',
  default: false,
});

export enum ContactUsPage {
  CONTACT_ARTICLE = 'CONTACT_ARTICLE',
  CONTACT_FORM = 'CONTACT_FORM',
  CONTACT_FORM_SURFACE_SAM = 'CONTACT_FORM_SURFACE_SAM',
}

export const contactUsPage = defineEnum({
  name: 'contactUsPage',
  description: 'Wheter or not to use contact page or new contact form and which buttons to surface',
  values: ContactUsPage,
  default: ContactUsPage.CONTACT_ARTICLE,
});

export const enableStandaloneSearchPage = defineBool({
  name: 'enableStandaloneSearchPage',
  description: 'Navigate to standalone search page when pressing enter key in the search bar',
  default: false,
});

export const enableCategoriesRedesign = defineBool({
  name: 'enableCategoriesRedesign',
  description: 'Whether to enable the new categories redesign on the homepage and articles',
  default: false,
});

export const properties: Array<PropertyRef> = [
  ubiTestBool,
  usePillowTalk,
  enableNewPremiumCloseAccount,
  contactUsPage,
  enableStandaloneSearchPage,
  enableCategoriesRedesign,
];

export type PropertyTypes = (typeof properties)[number]['_type'];
